import { clearKiosk, showKiosk } from 'admin/actions/devices';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import TableHeader from 'admin/components/shared/TableHeaders';
import TableRows from 'admin/components/shared/TableRows';
import { formatDate, formatNum, formatUUID } from 'admin/utils';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DetailTable from './DetailTable';
import RemoteInstruction from './RemoteInstruction';
import styles from './styles.scss';

const viewRow = (rowItem) => {
  if (rowItem === 'OK') {
    return <div style={{ color: 'green' }}>{rowItem}</div>;
  } else if (rowItem === 'Error') {
    return <div style={{ color: 'red' }}>{rowItem}</div>;
  } else if (rowItem === 'Warning') {
    return <div style={{ color: 'orange' }}>{rowItem}</div>;
  }
  return rowItem;
};

const makeHealthRows = (kiosk) => {
  const latestHealth = kiosk.latest_health;
  if (latestHealth) {
    return [
      [
        { data: 'ネットワーク' },
        { data: viewRow(kiosk.is_network_alive ? 'OK' : 'Error') },
        { data: '' },
      ],
      [
        { data: 'コインメック' },
        { data: viewRow(latestHealth.coinmech) },
        { data: latestHealth.coinmech_message, align: 'left' },
      ],
      [
        { data: 'ビルバリ' },
        { data: viewRow(latestHealth.bill_validator) },
        { data: latestHealth.bill_validator_message, align: 'left' },
      ],
      [
        { data: 'プリンタ' },
        { data: viewRow(latestHealth.printer) },
        { data: latestHealth.printer_message, align: 'left' },
      ],
      [
        { data: 'エスクロ' },
        { data: viewRow(latestHealth.escrow) },
        { data: latestHealth.escrow_message, align: 'left' },
      ],
      [
        { data: '前扉' },
        { data: viewRow(latestHealth.front_door) },
        { data: latestHealth.front_door_message, align: 'left' },
      ],
      [
        { data: 'CAT' },
        { data: viewRow(latestHealth.cat) },
        { data: latestHealth.cat_message, align: 'left' },
      ],
      [
        { data: 'UPS' },
        { data: viewRow(latestHealth.ups) },
        { data: latestHealth.ups_message, align: 'left' },
      ],
      [{ data: 'App Version' }, { data: '' }, { data: latestHealth.app_version, align: 'left' }],
      [
        { data: 'Browser Location' },
        { data: '' },
        { data: latestHealth.browser_location, align: 'left' },
      ],
    ];
  } else {
    return []; /* 一度も稼働していない場合 */
  }
};

class Kiosk extends Component {
  componentDidMount() {
    this.fetchKioskDetail();
  }

  componentWillUnmount() {
    this.props.clearKiosk();
  }

  fetchKioskDetail() {
    this.props.showKiosk(this.props.match.params.id);
  }

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '各種設定', href: '', active: true },
      { value: 'デバイス管理', href: '/settings/devices', active: false },
      { value: 'チャージ機詳細', href: '', active: true },
    ];
    const coinsColumns = [
      { label: '合計金額', align: 'center', size: 2 },
      { label: '合計枚数', align: 'center', size: 1 },
      { label: '1円', align: 'center', size: 1 },
      { label: '5円', align: 'center', size: 1 },
      { label: '10円', align: 'center', size: 1 },
      { label: '50円', align: 'center', size: 1 },
      { label: '100円', align: 'center', size: 1 },
      { label: '500円', align: 'center', size: 1 },
    ];
    const billsColumns = [
      { label: '合計金額', align: 'center', size: 2 },
      { label: '合計枚数', align: 'center', size: 1 },
      { label: '1000円', align: 'center', size: 1 },
      { label: '2000円', align: 'center', size: 1 },
      { label: '5000円', align: 'center', size: 1 },
      { label: '10000円', align: 'center', size: 1 },
      { label: '', align: 'center', size: 1 },
      { label: '', align: 'center', size: 1 },
    ];
    const totalColumns = [
      { label: '合計金額', align: 'center', size: 2 },
      { label: '', align: 'center', size: 1 },
      { label: '', align: 'center', size: 1 },
      { label: '', align: 'center', size: 1 },
      { label: '', align: 'center', size: 1 },
      { label: '', align: 'center', size: 1 },
      { label: '', align: 'center', size: 1 },
      { label: '', align: 'center', size: 1 },
    ];
    const coinsRows = [
      [
        { data: `¥ ${formatNum(this.props.kiosk.coin_amount)}`, align: 'center' },
        { data: this.props.kiosk.coin_count, align: 'center' },
        { data: this.props.kiosk.coin_1, align: 'center' },
        { data: this.props.kiosk.coin_5, align: 'center' },
        { data: this.props.kiosk.coin_10, align: 'center' },
        { data: this.props.kiosk.coin_50, align: 'center' },
        { data: this.props.kiosk.coin_100, align: 'center' },
        { data: this.props.kiosk.coin_500, align: 'center' },
      ],
    ];
    const billsRows = [
      [
        { data: `¥ ${formatNum(this.props.kiosk.bill_amount)}`, align: 'center' },
        { data: this.props.kiosk.bill_count, align: 'center' },
        { data: this.props.kiosk.bill_1000, align: 'center' },
        { data: this.props.kiosk.bill_2000, align: 'center' },
        { data: this.props.kiosk.bill_5000, align: 'center' },
        { data: this.props.kiosk.bill_10000, align: 'center' },
      ],
    ];
    const totalRows = [
      [{ data: `¥ ${formatNum(this.props.kiosk.total_amount)}`, align: 'center' }],
    ];
    const healthColumns = [
      { label: 'デバイス', align: 'center', size: 1 },
      { label: '状態', align: 'center', size: 1 },
      { label: '詳細', align: 'center', size: 5 },
    ];
    const healthRows = makeHealthRows(this.props.kiosk);
    return (
      <div>
        <Breadcrumb items={crumb} />
        <RemoteInstruction kioskId={this.props.kiosk.id} />
        <div styleName="headline">基本情報</div>
        <DetailTable label="チャージ機ID" item={this.props.kiosk.id} />
        <DetailTable label="端末名" item={this.props.kiosk.name} />
        <DetailTable label="設置店舗名" item={this.props.kiosk.shop} />
        <DetailTable label="マネー名" item={this.props.kiosk.money_name} />
        <DetailTable label="端末ID" item={formatUUID(this.props.kiosk.terminal_id)} />
        <DetailTable label="ハードウェアID" item={formatUUID(this.props.kiosk.hardware_id)} />
        <DetailTable label="作成日時" item={formatDate(this.props.kiosk.created_at)} />
        <DetailTable label="更新日時" item={formatDate(this.props.kiosk.updated_at)} />
        <br />
        <div styleName="headline">現金在庫</div>
        <div styleName="label">硬貨</div>
        <div styleName="list-table">
          <TableHeader columns={coinsColumns} />
          <TableRows rows={coinsRows} columns={coinsColumns} />
        </div>
        <div styleName="label">紙幣</div>
        <div styleName="list-table">
          <TableHeader columns={billsColumns} />
          <TableRows rows={billsRows} columns={billsColumns} />
        </div>
        <div styleName="label">合計</div>
        <div styleName="list-table">
          <TableHeader columns={totalColumns} />
          <TableRows rows={totalRows} columns={totalColumns} />
        </div>
        <br />
        <div styleName="headline">デバイス監視</div>
        <div styleName="list-table">
          <TableHeader columns={healthColumns} />
          <TableRows rows={healthRows} columns={healthColumns} />
        </div>
      </div>
    );
  }
}

Kiosk.defaultProps = {
  kiosk: { latest_health: {} },
  showKiosk: PropTypes.func,
  clearKiosk: PropTypes.func,
};

Kiosk.propTypes = {
  showKiosk: PropTypes.func,
  clearKiosk: PropTypes.func,
  kiosk: PropTypes.shape({
    id: PropTypes.number,
    terminal_id: PropTypes.string,
    name: PropTypes.string,
    shop: PropTypes.string,
    money_name: PropTypes.string,
    hardware_id: PropTypes.string,
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
    coin_1: PropTypes.number,
    coin_5: PropTypes.number,
    coin_10: PropTypes.number,
    coin_50: PropTypes.number,
    coin_100: PropTypes.number,
    coin_500: PropTypes.number,
    coin_count: PropTypes.number,
    coin_amount: PropTypes.number,
    bill_1000: PropTypes.number,
    bill_2000: PropTypes.number,
    bill_5000: PropTypes.number,
    bill_10000: PropTypes.number,
    bill_count: PropTypes.number,
    bill_amount: PropTypes.number,
    total_amount: PropTypes.number,
    is_network_alive: PropTypes.bool,
    latest_health: PropTypes.shape({
      coinmech: PropTypes.string,
      coinmech_message: PropTypes.string,
      bill_validator: PropTypes.string,
      bill_validator_message: PropTypes.string,
      printer: PropTypes.string,
      printer_message: PropTypes.string,
      escrow: PropTypes.string,
      escrow_message: PropTypes.string,
      front_door: PropTypes.string,
      front_door_message: PropTypes.string,
      cat: PropTypes.string,
      cat_message: PropTypes.string,
      ups: PropTypes.string,
      ups_message: PropTypes.string,
      app_version: PropTypes.string,
      browser_location: PropTypes.string,
    }),
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  kiosk: state.device.kiosk,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showKiosk,
      clearKiosk,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(Kiosk, styles));
